import debounce from "lodash/debounce"

let localStorageAvailable = () => {
    let test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
};

let storageKey = (state) => {
    return `booking_state_${state.tourId}_${state.tourStartDateId}`;
};

let debouncedUpdate = debounce((state) => {
    localStorage.setItem(storageKey(state), JSON.stringify(state));
}, 200);

let setupLocalStorage = (store) => {
    let previous = localStorage.getItem(storageKey(store.state));

    if (previous) {
        store.replaceState(JSON.parse(previous));
    }
};

const VuexLocalStorage = (store) => {

    if (!localStorageAvailable()) {
        return false;
    }

    let initialized = false;

    store.subscribe((mutation, state) => {

        if (mutation.type === "restoreState") {
            initialized = true;
            setupLocalStorage(store);
        }


        if (initialized) {
            debouncedUpdate(state);
        }
    });
};

export default VuexLocalStorage;